<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="prologue">
<h1>Prologue</h1>
<div class="section level2" id="midnight-falls">
<h2>Midnight Falls</h2>
<p>A soft cry came out of his mouth as mist crept slyly out. The moon received his cries but did not echo them far enough. He had a pack once, and he left. He left because he didn’t fit in and he couldn’t stay there anymore. Although when night fell, he longed for their howls, every night his cries grew louder as he prayed for an answer, but no answer ever came. He longed for the warmth of his pack, but he felt cold. He longed for the times the pack hunted together, now he hunted alone. It was all these things that made him shun the world. He didn’t fit in, love wasn’t for him anymore. He tried to love but he couldn’t since that day, no, he was alone in the world, nothing could change that, right?</p>
<p>With these thoughts in his head he stumbled upon in the snow, trying to find an empty trunk to shelter himself for the night. Prey was scarce and shelter was vulnerable to the cold, yet he survived. He was agile, strong and independent and yet, there was an empty hole inside that no one could seem to fill.</p>
<p>As mist crept out slyly from his mouth, he snuggled to a corner and wrapped his tail around his legs, trying to find the seemingly impossible warmth he was craving, on this cold winter night. After rolling over several times, trying to find comfort on the harsh surface beneath him, his eyelids sealed shut as he fell into uncomfortable dreams.</p>
<p>He found himself standing in the middle of a wasteland, his padded, dark blue fur covering his silver, embedded star pattern; standing out like the stars in a cloudless night sky. A faint yet familiar voice filled his ears, calling out to him a different sentence every night. He didn’t understand all of them. “Giving up is everyone’s favourite answer. It’s the easiest route, but also the worst, you can probably think of.” With that, the dream ended and his eyes fluttered open. Vortex was frustrated, angry and miserable: even though he knew the voice, he never knew where it came from. Sleepily, his metallic grey eyes glanced around at his surroundings, his muscles weak with pain. Gradually, he lifted himself up.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2d4c74fc